import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { usePatch } from "redux/fetch-hooks";
import { heapTrack } from "lib/analytics";

import CandidateCheckInSummary from "candidate/CheckIn/CandidateCheckInSummary";

type ReduxState = {
    is_preview: boolean;
    ws: { demo: { enabled: boolean } };
};

type Props = {
    companyName?: string;
    checkinHireId?: number | null;
    checkinHash?: string | null;
    checkinType?: number | null;
    checkinThankYouTitle?: string | null;
    checkinThankYouMessage?: string | null;
};

function CheckInSummary({
    companyName = "",
    checkinHireId = null,
    checkinHash = null,
    checkinType = null,
    checkinThankYouTitle = null,
    checkinThankYouMessage = null,
}: Props) {
    const [runPatch] = usePatch(`/api/v1/checkin-hire/${checkinHireId ?? ""}/`);
    const isPreview = useSelector((state: ReduxState) => state.is_preview);
    const isDemo = useSelector((state: ReduxState) => state.ws.demo.enabled);

    // Mark the CheckinHire as complete when the user reaches the end of the
    // checkin, even if they skipped some of the questions.
    useEffect(() => {
        if (isPreview || isDemo) {
            return;
        }
        runPatch({ data: { is_complete: true, checkin_hash: checkinHash } });

        const params = new URLSearchParams(window.location.search);

        if (params.get("utm_source") === "hub" && isDemo) {
            heapTrack("Demo Hub Survey Finished", { checkinHireId });
        }

        if (params.get("utm_source") === "hub" && !isDemo) {
            heapTrack("Hub Survey Completed", { checkinHireId });
        }
    }, [checkinHireId, isPreview]);

    return (
        <CandidateCheckInSummary
            companyName={companyName}
            checkinType={checkinType ?? 0}
            checkinThankYouTitle={checkinThankYouTitle}
            checkinThankYouMessage={checkinThankYouMessage}
        />
    );
}

export default CheckInSummary;
